import { Dimensions, Platform } from 'react-native';

const width = Dimensions.get('window').width;
const height = Dimensions.get('window').height;

export default {
  window: {
    width,
    height,
  },
  isSmallDevice: width < 375,
};




export const PADDING_HORIZONTAL_MODAL = 30;

// reading column of sessions and activity pages (see useContentMaxWidth):
// the whole width on phones, then CONTENT_WIDTH_RATIO of the available width,
// between CONTENT_MIN_WIDTH and CONTENT_MAX_WIDTH
export const CONTENT_MIN_WIDTH = 640;
export const CONTENT_MAX_WIDTH = 960;
export const CONTENT_WIDTH_RATIO = 0.75;

export const WIDTH_PATH_FN = (width: number) => {
  const LOWER_BOUND = 100;
  const UPPER_BOUND = 300;
  const NB_PATHS_VISIBLE = 1;
  const PERCENT_LAST_PATH_VISIBLE = 85;
  const ALL_MARGINS = PADDING_LEFT_DASHBOARD(width) + (2*NB_PATHS_VISIBLE+1)*MARGIN_HORIZONTAL_DASHBOARD_ITEM(width);
  const WIDTH_NO_BOUND = (width - ALL_MARGINS)/(NB_PATHS_VISIBLE + PERCENT_LAST_PATH_VISIBLE/100);
  return Math.max(LOWER_BOUND, Math.min(UPPER_BOUND, WIDTH_NO_BOUND));
};

export const WIDTH_PSYCHO_CARD = (width: number) => {
  const LOWER_BOUND = 100;
  const UPPER_BOUND = 250;
  const NB_PATHS_VISIBLE = 1;
  const PERCENT_LAST_PATH_VISIBLE = 15;
  const ALL_MARGINS = 0 + (2*NB_PATHS_VISIBLE+1)*REGULAR_HORIZONTAL_MARGIN_FN(width*2);
  const WIDTH_NO_BOUND = (width - ALL_MARGINS)/(NB_PATHS_VISIBLE + PERCENT_LAST_PATH_VISIBLE/100);
  return Math.max(LOWER_BOUND, Math.min(UPPER_BOUND, WIDTH_NO_BOUND));
};

export const WIDTH_ACTIVITY_FN = (width: number) => {
  const LOWER_BOUND = 100;
  const UPPER_BOUND = 250;
  const NB_PATHS_VISIBLE = 2;
  const PERCENT_LAST_PATH_VISIBLE = 15;
  const ALL_MARGINS = PADDING_LEFT_DASHBOARD(width) + (2*NB_PATHS_VISIBLE+1)*MARGIN_HORIZONTAL_DASHBOARD_ITEM(width);
  const WIDTH_NO_BOUND = (width - ALL_MARGINS)/(NB_PATHS_VISIBLE + PERCENT_LAST_PATH_VISIBLE/100);
  return Math.max(LOWER_BOUND, Math.min(UPPER_BOUND, WIDTH_NO_BOUND));
};


export const WIDTH_OTHERS_FN = (width: number) => {
  const width_path = WIDTH_PATH_FN(width);
  return width_path * 2 / 3 - 7; // check it
};

export const HEIGHT_PATH_FN = (width: number) => {
  const width_path = WIDTH_PATH_FN(width);
  return 112*width_path/160;
};


export const HEIGHT_ACTIVITY_FN = (width: number) => {
  const width_activity = WIDTH_ACTIVITY_FN(width);
  return 112*width_activity/160;
};





export const MARGIN_FN = (width: number) => {
  const width_others_fn = WIDTH_OTHERS_FN(width);
  return width_others_fn * 0.15;
};

export const PADDING_LEFT_DASHBOARD = (width : number) => {
  return REGULAR_HORIZONTAL_MARGIN_FN(width);
};

export const MARGIN_HORIZONTAL_DASHBOARD_ITEM = (width : number) => {
  return REGULAR_HORIZONTAL_MARGIN_FN(width);
};

export const WEB_HORIZONTAL_MARGIN_FN = (width: number) => {
  return Math.max(40, Math.min(width / 5));
};
export const BIG_HORIZONTAL_MARGIN_FN = (width: number) => {
  return Math.max(20, width * 0.05);
};

export const VERY_BIG_HORIZONTAL_MARGIN_FN = (width: number) => {
  return Math.max(20, width * 0.05);
};

export const REGULAR_HORIZONTAL_MARGIN_FN = (width: number) => {
  return Math.max(10, width * 0.025);
};

export const SMALL_HORIZONTAL_MARGIN_FN = (width: number) => {
  return Math.max(5, width * 0.0125);
};

export const WEB_MARGIN_VERTICAL_FN = (height: number) => {
  return Math.max(35, Math.min(height / 4.5));
};

export const HUGE_MARGIN_VERTICAL_FN = (height: number) => {
  return Math.max(20, height * 0.08);
};

export const BIG_MARGIN_VERTICAL_FN = (height: number) => {
  return Math.max(15, height * 0.06);
};

export const REGULAR_MARGIN_VERTICAL_FN = (height: number) => {
  return Math.max(10, height * 0.04);
};

export const SMALL_MARGIN_VERTICAL_FN = (height: number) => {
  return Math.max(5, height * 0.02);
};

export const TINY_MARGIN_VERTICAL_FN = (height: number) => {
  return Math.max(2, height * 0.01);
};

export const REGULAR_FONT_SIZE_FN = (width: number) => {
  const LOWER_BOUND = 12;
  const UPPER_BOUND = 24;
  return Math.max(LOWER_BOUND, Math.min(UPPER_BOUND, width / 120));
};


export const BIG_FONT_SIZE_FN = (width: number) => {
  const LOWER_BOUND = 14;
  const UPPER_BOUND = 32;
  return Math.max(LOWER_BOUND, Math.min(UPPER_BOUND, width / 80));
};

export const SIZE_ICON_CHALLENGE = 12;



export const isWeb = Platform.OS === 'web';
export const isAndroid = Platform.OS === 'android';
export const isIos = Platform.OS === 'ios';

